import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  collection,
  getDocs,
  getDoc,
  query,
  where,
  limit
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

// ==========================
// 🔹 Constants
// ==========================
export const dbCollections = {
  COURSES: "courses", // ✅ Changed from BLOGS → COURSES
};

export const storageCollections = {
  COURSES: "courses", // ✅ Changed from BLOGS → COURSES
};

// ==========================
// 🔹 Your Firebase Config
// ==========================
const firebaseConfig = {
  apiKey: "AIzaSyBB6L3m6LugXM1vQAlzHXOKCterqwq1WqE",
  authDomain: "btech-mathematics-eb095.firebaseapp.com",
  projectId: "btech-mathematics-eb095",
  storageBucket: "btech-mathematics-eb095.firebasestorage.app",
  messagingSenderId: "1098566357203",
  appId: "1:1098566357203:web:43e80f6c26d79e4e718426",
  measurementId: "G-QVNYHNDY90"
};

// ==========================
// 🔹 Initialize Firebase
// ==========================
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// ==========================
// 🔹 Fetch All Courses
// ==========================
export async function getCourses() {
  try {
    const coursesCollection = collection(db, dbCollections.COURSES);
    const snapshot = await getDocs(coursesCollection);

    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw error;
  }
}

// ==========================
// 🔹 Fetch Single Course (by condition)
// ==========================
export async function getSingleCourse({ collectionName, condition }) {
  try {
    const q = query(collection(db, collectionName), condition, limit(1));
    const snapshot = await getDocs(q);

    if (!snapshot.empty) {
      return {
        id: snapshot.docs[0].id,
        ...snapshot.docs[0].data(),
      };
    }
    return null;
  } catch (error) {
    console.error("Error fetching single course:", error);
    throw error;
  }
}
